/** @format */

import { useCallback, useState } from "react";
import {
  deleteDokumenRencanaDefinitif,
  getDokumenRencanaDefinitif,
  statusDokumenRencanaDefinitif,
} from "services/v2/planningservice/rencanapendapatandefinitif";
import { getFileMadrasahManual } from "services/v2/planningservice/uploadmanualservices";
import { getDokumenRencanaDefinitifAxios } from "services/v2/reportservice";

export const useDokumenBos = (
  dataMadrasah: any,
  auth: any,
  activeTabKey: any,
) => {
  const [loadingDokumen, setLoading] = useState<boolean>(false);
  const [filesBos, setFilesBos] = useState<any>(null);
  const [filesDoc, setFilesDoc] = useState<any>(null);
  const [fileList, setFileList] = useState<any>([]);

  const getFileList = useCallback(async () => {
    setLoading(true);
    if (activeTabKey === "pm2") {
      try {
        let params: any = `&tahun=${dataMadrasah?.tahun}&nsm=${dataMadrasah?.nsmMadrasah}&tahap=${dataMadrasah?.tahap}`;
        const res = await getFileMadrasahManual(params);
        if (res) {
          let result: any =
            (res?.length &&
              res.filter((item) => item?.jenisMadrasah === "M")) ||
            [];
          setFileList(result || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        let params: any = `?tahun=${dataMadrasah?.tahun}&madrasahId=${dataMadrasah?.madrasahId}`;
        const res = await getDokumenRencanaDefinitif(params);
        if (res) {
          let result: any =
            (res?.length &&
              res.filter((item) => item?.jenisMadrasah === "R")) ||
            [];
          setFileList(result || []);
        }
      } catch (error) {
        console.log(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMadrasah?.madrasahId, dataMadrasah?.nsmMadrasah, activeTabKey]);

  const getFiles = useCallback(
    async (fileDoc: any) => {
      setLoading(true);
      try {
        const res: any = await getDokumenRencanaDefinitifAxios(
          fileDoc,
          auth,
          fileDoc?.typeDoc,
          dataMadrasah,
        );
        setFilesBos(res);
        setFilesDoc(fileDoc);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataMadrasah?.madrasahId, dataMadrasah?.nsmMadrasah, auth?.isTahun],
  );

  const validasiFileDokumen = useCallback(
    async (values: any) => {
      setLoading(true);
      try {
        const res = await statusDokumenRencanaDefinitif(
          `${values?.id}?statusValidasi=${values?.statusValid}&keterangan=${values?.keterangan}`,
        );
        return res;
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataMadrasah?.madrasahId, dataMadrasah?.nsmMadrasah, auth?.isTahun],
  );

  const deleteFileDokumen = useCallback(async (values: any) => {
    setLoading(true);
    try {
      const res = await deleteDokumenRencanaDefinitif(values?.id);
      return res;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loadingDokumen,
    filesBos,
    filesDoc,
    fileList,
    getFileList,
    getFiles,
    validasiFileDokumen,
    deleteFileDokumen,
  };
};
